export const aboutData = [
  {
    title: "Envotion (Deployed at NVIDIA)",
    sub_title: "System Software Engineer | Aug 2023 - current",
    description1: `• Developing Hypervisor (An abstraction layer between application
      and hardware layer).`,
    description2:
      "• Unit Tested the API's to observe their behaviour according to condition.",
    description3:
      "• Did Integration testing to observe behaviour of their API's.",
    description4:
      "• Implemented Mocking for unit testing, for all database dependencies.",
    description5:
      "• Used MVC architecture which makes code modular and scalable and used Axios to call API’s from frontend.",
    description6:
      "• Tech stack - ASP.Net, C#, Vue.js, Microsoft SQL Server, BDD",
    image: 2,
  },
  {
    title: "DeltaX - An AI-Driven Advertising Company",
    sub_title: "Product Engineer Intern | March 2023 - Aug 2023",
    description1: `• Developed IMDB Application providing various functionalities for
    movies, actors, producers, genres etc. using Vue.js, C# and ASP.NET.`,
    description2:
      "• Designed the Database for the same and used Stored Procedures for adding and updating movies and Dapper to interact with database.",
    description3:
      "• Used BDD for testing the features using Specflow & Gherkin syntax.",
    description4:
      "• Implemented Mocking for unit testing, for all database dependencies.",
    description5:
      "• Used MVC architecture which makes code modular and scalable and used Axios to call API’s from frontend.",
    description6:
      "• Tech stack - ASP.Net, C#, Vue.js, Microsoft SQL Server, BDD",
    image: 2,
  },
  {
    title: "AGROGRAM - An Agri Solution Company",
    sub_title: "Software Developer Intern | March 2021 - May 2021",
    description1: `• Collaborated with a team to create Store Section and Admin Panel from scratch.`,
    description2:
      "• Collaborated with a team to create Store Section and Admin Panel from scratch.",
    description3:
      "• Used Node.js and Express.js for login and Authentication of admin panel.",
    description4:
      "• Stored all Agrogram related information in MongoDB Database.",
    description5: "• Technology used - MEAN Stack",
    image: 2,
  },
];
